module.exports = __webpack_public_path__ + "img/1.8537fe32.jpg";